import {
  Box,
  Button,
  Divider,
  HStack,
  Heading,
  List,
  ListIcon,
  ListItem,
  Modal,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  Text,
  VStack,
} from '@chakra-ui/react'
import { CheckIcon } from '@chakra-ui/icons'
import { FC } from 'react'

export interface PaywallModalProps {
  isOpen: boolean
  onClose: () => void
  onUpgrade?: () => void
  isUpgrading?: boolean
}

const DEFAULT_FEATURES = [
  'Unlimited scripts & admin users',
  'Send scripts via SMS and email',
  'Real-Time Prescription Monitoring',
  'Self-managed team billing',
]

export const PaywallModal: FC<PaywallModalProps> = ({
  isOpen,
  onClose,
  onUpgrade,
  isUpgrading = false,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="xl"
      blockScrollOnMount={false}
      closeOnOverlayClick={false}
    >
      <ModalOverlay bg="blackAlpha.400" />
      <ModalContent borderRadius="lg" px={{ base: 6, md: 12 }} py={{ base: 6, md: 10 }}>
        <ModalCloseButton mt={2} mr={2} />

        <VStack align="stretch" spacing={4}>
          <Box>
            <Heading fontSize="lg" lineHeight="lg" letterSpacing="-0.02em">
              Upgrade to Unlimited
            </Heading>
            <Text mt={2} fontSize="sm" color="gray.600">
              For high-volume prescribers and teams
            </Text>
          </Box>

          <List spacing={2} color="gray.700" fontSize="sm">
            {DEFAULT_FEATURES.map((feature) => (
              <ListItem key={feature} display="flex" alignItems="flex-start">
                <ListIcon as={CheckIcon} color="green.400" mt="2px" />
                <Text>{feature}</Text>
              </ListItem>
            ))}
          </List>

          <Divider borderColor="gray.200" />

          <HStack align="baseline" justify="space-between" gap={2}>
            <HStack align="baseline" spacing={2}>
              <Text fontSize="4xl" fontWeight="bold" lineHeight="1" letterSpacing="-0.02em">
                $65
              </Text>
              <Text fontSize="md" fontWeight="medium" color="gray.600">
                /month
              </Text>
            </HStack>
            <Text fontSize="md" color="gray.600" whiteSpace="nowrap">
              Cancel anytime
            </Text>
          </HStack>

          <Button
            colorScheme="blue"
            borderRadius="lg"
            fontSize="md"
            onClick={onUpgrade}
            isLoading={isUpgrading}
            isDisabled={!onUpgrade}
          >
            Upgrade Now
          </Button>
        </VStack>
      </ModalContent>
    </Modal>
  )
}

export default PaywallModal
